import AsyncStorage from "@react-native-async-storage/async-storage"
import { activityPath, DEMO_FLOW_ENABLED } from "../../config/Constant";

export const fetchBookings = (callback=()=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        
        const { activities } = getState().demoDataSlice;
        try {
            if(DEMO_FLOW_ENABLED){
                callback(true, JSON.parse(JSON.stringify((activities?.fetchBooking?.payload?.Data?.items))));
                return
            }
            const response = await activityPath.post("/fetchBookings", {
                header: {
                    sessionToken
                },
                payload: {

                }
            })
            callback(true, response?.data?.payload?.Data?.items)
        } catch (error) {
            const errMessage = error?.response?.header?.status?.msg || error?.message || "Something Went wrong"
            callback(false, errMessage)
        }
    }
    
}


export const getEvents = (categoryIds, callback=()=>{})=>{
    return async (dispatch, getState) => {
        try {
            const { activities } = getState().demoDataSlice;

            if(DEMO_FLOW_ENABLED){
                callback(true, JSON.parse(JSON.stringify(activities?.getEvents?.payload?.data)))
                return
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const guestToken = await AsyncStorage.getItem("guestToken");
            const payload = {}
            if(categoryIds){
                payload.categoryIds = categoryIds
            }

            const response = await activityPath.post("/getEvents", {
                header: {
                    sessionToken: sessionToken,
                    guestToken: guestToken
                },
                payload: payload
            })

            if(response.data?.header?.status?.code == "SUCCESS" && !categoryIds){
                callback(true, response.data?.payload?.data)
            } else {
                callback(false, "Something went wrong")
            }
            
        } catch (error) {
            let errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}


export const getEventsInfo = (listingId, kind)=>{
    return async (dispatch, getState) => {
        try {
            const { activities } = getState().demoDataSlice;

            if(DEMO_FLOW_ENABLED){
                if(kind === "experience"){
                    return { eventInfo: JSON.parse(JSON.stringify(activities?.getEventsInfoExperience?.payload.data)) };
                } else if ( kind === "resource" ) {
                    return { eventInfo: JSON.parse(JSON.stringify(activities?.getEventsInfoSubEvents?.payload.data)) };
                } else {
                    return { eventInfo: JSON.parse(JSON.stringify(activities?.getEventsInfoEvent?.payload.data)) };
                }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');

            const response = await activityPath.post("/getEventsInfo", {
                header: {
                    sessionToken: sessionToken
                },
                payload: {
                    listingId
                }
            })

            if(response.data?.header?.status?.code == "SUCCESS"){
                return {eventInfo: response.data?.payload?.data}
            }
            
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }
    }
}

export const getAvailbility = (experienceId, experienceIdsList, callback=()=>{}, kind)=>{
    return async (dispatch, getState) => {
        try {
            const { activities } = getState().demoDataSlice;
            if(DEMO_FLOW_ENABLED){
                if(kind === "experience"){
                     callback(true, JSON.parse(JSON.stringify(activities?.getAvailabilityExperience?.payload.data)));
                } else if ( kind === "resource" ) {
                     callback(true, JSON.parse(JSON.stringify(activities?.getAvailabilitySubEvents?.payload.data)));
                } else {
                     callback(true, JSON.parse(JSON.stringify(activities?.getAvailabilityEvent?.payload.data)));
                }
                return
            }

            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const payload_ = {}
            if(experienceId) payload_.experienceId = experienceId
            if(experienceIdsList) payload_.experienceIdsList = experienceIdsList

            const response = await activityPath.post("/getAvailbility", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })

            if(response.data?.header?.status?.code == "SUCCESS"){
                callback(true, response.data?.payload?.data)
            } else {
                callback(false, response.data?.header?.status.msg);
            }
            
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }
    }
}


export const createWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: { bookingId: "ThisIsDemo" } }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');

            const response = await activityPath.post("/createBooking", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            });

            return { data: response?.data?.payload?.data };
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }

    }
}

export const cancelWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: "Booking cancelled successfully" }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
    
            const response = await activityPath.post("/cancel", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })
            return { data: response?.data?.payload?.data };

        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }
    }
}

export const updateMyWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: "Booking updated successfully" }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
        
            const response = await activityPath.post("/booking/reschedule", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })

            return { data: response?.data?.payload?.data };
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }  
        }
    }
}